export const INITIAL_VALUES = {
  email: '',
  first_name: '',
  last_name: '',
  password: '9x8tarqo93zgwumb8v0mp',
  phone: '',
};
